/** Room for a 1.6-unit native model to turn diagonally without occupying another slot. */
export const BATTLE_SLOT_POSITIONS: Readonly<Record<string, readonly [number, number]>> = {
  f1: [1.6, -3.6], f2: [1.6, -1.2], f3: [1.6, 1.2], f4: [1.6, 3.6],
  commander: [4.1, 0], s1: [4.1, -3.6], s2: [4.1, 3.6],
  extra: [0.6, 0], turret: [6.6, 0],
};
